import axios from "axios";

let requests = axios.create({
    //基础路径,发请求URL携带api【发现:真实服务器接口都携带/api】
    // baseURL: "/img2/",  //测试
    baseURL: process.env.VUE_APP_BASE_URL_IMG2,  //正式
    //超时的设置
    timeout: 5000
});

// //请求拦截器:将来项目中【N个请求】，只要发请求,会触发请求拦截器!!!
requests.interceptors.request.use(config => {
    //请求拦截器:请求头【header】,请求头能否给服务器携带参数

    //每一次发请求,请求头携带用户临时身份
    config.headers.userTempId = 'hbrb_app';
    //不管那个模块发请求,请求拦截器，都可以触发。请求拦截器可以通过请求头每一次协大公共参数给服务器【用户未登录的临时身份】
    config.headers.token1 = 'xxxxx';
    config.headers['stoken1'] = 'aaaa';

    // if (config.method === 'post') {  //axios发送POST请求时默认使用application/json格式来传递数据。如果使用form，则在axios的请求拦截器中添加配置，将请求头的Content-Type设置为application/x-www-form-urlencoded。
    //     config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
    // }

    // if (config.method === 'jsonp') {
    //     const callbackName = `jsonp${new Date().getTime()}`
    //     const script = document.createElement('script')
    //     script.src = `${config.url}?callback=${callbackName}`
    //     document.body.appendChild(script)
    //     return new Promise(resolve => {
    //       window[callbackName] = data => {
    //         resolve({
    //           data
    //         })
    //         document.body.removeChild(script)
    //         delete window[callbackName]
    //       }
    //     })
    //   }

    return config;
});

//响应拦截器：请求数据返回会执行
requests.interceptors.response.use((res) => {
    //res:实质就是项目中发请求、服务器返回的数据
    return res.data;
}, (err) => {
    //温馨提示:某一天发请求,请求失败,请求失败的信息打印出来
    console.log(err.message);
    return false;
    //终止Promise链
    // return new Promise();
});

//最后需要暴露:暴露的是添加新的功能的axios,即为requests
export default requests;